import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52c36cd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onDragenter", "onDragleave", "onDrop"]
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "dropzoneFile" }, "Wgraj plik", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "dropzoneFile" }, "Wgraj nowy plik", -1))
const _hoisted_7 = { class: "text-center font-medium font-roboto mt-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "file",
  id: "dropzoneFile",
  class: "dropzoneFile"
}, null, -1))

import { ref } from 'vue';


export default {
  __name: 'Dropzone',
  props: {
    active: {
        type: Boolean,
        default: false,
    },
    selectedFile: {
        type: Object,
        default: null,
    },
},
  setup(__props) {

const props = __props;



const active = ref(false);

const toggleActive = () => {
    active.value = !active.value;
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    onDragenter: _withModifiers(toggleActive, ["prevent"]),
    onDragleave: _withModifiers(toggleActive, ["prevent"]),
    onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _withModifiers(toggleActive, ["prevent"]),
    class: _normalizeClass([{ 'active-dropzone': active.value }, "dropzone"])
  }, [
    (__props.selectedFile === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", {
            class: "text-center text-[11px] font-roboto mt-2",
            style: _normalizeStyle({ color: active.value ? '#fff' : '#676767' })
          }, [
            _createTextVNode(" lub przeciągnij i upuść tutaj "),
            _hoisted_4,
            _createTextVNode(" akceptowalne formaty: pdf, jpg, png ")
          ], 4)
        ]))
      : _createCommentVNode("", true),
    (__props.selectedFile !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, " Wybrany plik: " + _toDisplayString(__props.selectedFile.name), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_8
  ], 42, _hoisted_1))
}
}

}